// Mirror the cascade order AO gets under the shell: Vuetify component CSS, then vuetify/styles
// (utilities), then AO's own CSS. Standalone, the component CSS comes from the shared fallback chunk,
// which the federation runtime injects at load time, so everything after it must load dynamically too.
await Promise.all([import('vuetify/components'), import('vuetify/directives')]);
await import('vuetify/styles');
const { createAssortmentApp } = await import('./src/create-app');
const { STYLE_SCOPE_CLASS } = await import('./src/webshell-embed/embedded');

// Standalone entry, for per-client deployments and local dev. The federated remote entry
// (src/webshell-embed/WebshellMain.vue) calls the same factory after putting AO into embedded mode.
//
// MSW belongs here rather than in the shared factory: the embedded remote runs in the shell's
// document and must never register a service worker there. Started before the app so the mocks
// intercept its context XHRs.
if (import.meta.env.VITE_ENABLE_MSW === 'true') {
  const { worker } = await import('./msw-browser-worker');
  await worker.start({
    serviceWorker: { url: '/mockServiceWorker.js' },
    onUnhandledRequest: 'bypass',
  });
}

// AO's CSS is scoped under the style scope class at build time (vite.config.js). Standalone mounts
// under <body>, which needs the class for the styles to apply page-wide; embedded, WebshellMain.vue's
// host div is the ancestor instead.
document.body.classList.add(STYLE_SCOPE_CLASS);

createAssortmentApp({ mountTarget: '#app', routerBase: import.meta.env.BASE_URL });
